import './components';
import './stores';
import { debounce } from 'lodash';
import {
  makeCarousel,
  makeUnmountedCarousel,
} from '../../auto/utils/carousel/splide';
import { initSectionWhenItIsVisible } from '../../auto/utils/initSectionWhenItIsVisible';
import hookConversion from '../../auto/utils/hookConversion';
import openModal from '../../auto/utils/openModal';
import Micromodal from '../../auto/micromodal';

window.makeCarousel = makeCarousel;
window.makeUnmountedCarousel = makeUnmountedCarousel;
window.debounce = debounce;
window.Micromodal = Micromodal;

window.hookConversion = hookConversion;

window.helpers = {
  ...helpers,
  initSectionWhenItIsVisible,
};

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', openModal);
});
